import { render } from "./AddSubItem.vue?vue&type=template&id=0059981e"
import script from "./AddSubItem.vue?vue&type=script&lang=js"
export * from "./AddSubItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__